import { useState } from 'react'
import FnOListingWidgetV1 from '@/components/Stocks/FnO/ListingWidgetV1'
import Text from '@/stories/components/Common/NewText'
import { ICategory } from '@/components/Stocks/FnO/types/options-chain'
import { categories } from '@/components/Stocks/FnO/constants'

const FnOCallPutV1 = ({
  categoryData,
  heading = 'Options',
  isStocks = false,
  short_name,
}: {
  categoryData?: { categories?: ICategory[] }
  heading?: string
  isStocks?: boolean
  short_name?: string
}) => {
  const [selectedCategory, setSelectedCategory] = useState(categories[0])

  const allowedCategories = categoryData?.categories?.filter(
    item =>
      categories.includes(item.category_name.toUpperCase()) &&
      !!item.stocks?.length,
  )
  if (!allowedCategories?.length) return null

  const list = categoryData?.categories?.find(
    item => item.category_name.toUpperCase() === selectedCategory,
  )

  return (
    <div className="flex flex-col  ">
      <div className="flex items-center justify-between">
        <Text appearance="heading3">
          {isStocks ? `${short_name} ` : ''}
          {heading}
        </Text>
        <div className="bg-brand-tertiary-grey flex justify-end rounded-full">
          {categories.map(category => (
            <button
              key={category}
              className={`${
                selectedCategory === category
                  ? 'bg-brand-tertiary-blue border-brand-blue-azureRadiance text-brand-blue-azureRadiance rounded-full border'
                  : 'text-brand-grey-base '
              }  px-2.5 py-1`}
              onClick={() => setSelectedCategory(category)}
            >
              <Text appearance="overline">{category}</Text>
            </button>
          ))}
        </div>
      </div>

      {!!list?.stocks?.length && (
        <FnOListingWidgetV1 categoryData={list.stocks} key={selectedCategory} />
      )}
    </div>
  )
}

export default FnOCallPutV1
